import { getNativeConfig } from 'src/config/brandings/konecto/nativeConfig.ts'

module.exports = () => {
  return {
    app_name: 'Konecto-Sdui',
    styles: {
      load: () => import(/* webpackChunkName: "styleKonectoSdui" */'src/config/brandings/konecto/index.scss')
    },
    meta: {
      meta: [
        { name: 'apple-itunes-app', content: 'app-id=6447056413' },
        { name: 'og:image', content: '/brandings/konecto/favicons/favicon-192x192.png' },
        { name: 'twitter:image', content: '/brandings/konecto/favicons/favicon-192x192.png' }
      ],
      link: [
        { rel: 'shortcut icon', href: '/brandings/konecto/favicons/favicon-32x32.png', type: 'image/png' },
        { rel: 'icon', href: '/brandings/konecto/favicons/favicon.ico', type: 'image/x-icon' }
      ]
    },
    logos: {
      logo: 'brandings/konecto/logo/logo.svg'
    },
    search: {
      queries: {
        branding: 'KONECTO-SDUI'
      }
    },
    start: {
      description: 'public.start.security',
      image: false,
      show_more: false,
      sdui_authenticator: false
    },
    management: {
      show_announcements: true,
      show_material_page: true,
      additional_content: {
        infos: 'branding["konecto-sdui"].management.additional_content.infos'
      }
    },
    ui: {
      show_hint_cards: true,
      show_video_hint: true
    },
    settings: {
      notifications: {
        email_newsletter: false
      }
    },
    dataProtection: {
      show_go_to_sdui_website: false
    },
    onboarding: {
      help_videos: true
    },
    keepAlivePing: false,
    appSwitcher: {
      show_marketing: false
    },
    login: {
      registration_code: true,
      hideSduiLoginDefault: false,
      sduiLoginDefaultExpanded: false,
      form: {
        inline_reset_password: true
      }
    },
    ...getNativeConfig()
  }
}
